<template>
  <transition name="fade">
    <div
      v-if="notification"
      class="notification-toast alert alert-dismissible position-relative d-flex align-items-start text-white border-0 rounded-1"
      :class="notificationTypeClass"
      role="alert"
    >
      <base-button
        @click="removeNotification(notification)"
        type="button"
        class="position-absolute top-0 end-0 border-0 bg-transparent pe-2"
      >
        <i class="mdi mdi-close-thick font-16" />
      </base-button>
      {{ notification?.message }}
    </div>
  </transition>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'

import { useStore } from 'vuex'

import BaseButton from '@/components/BaseButton'

const props = defineProps({
  notification: {
    type: Object,
    required: true
  }
})
const timeout = ref(null)

const store = useStore()

const notificationTypeClass = computed(() => `alert-${props.notification.type} bg-${props.notification.type}`)

const removeNotification = value => {
  store.dispatch('notification/remove', value)
}

onMounted(() => {
  timeout.value = setTimeout(() => removeNotification(props.notification), 8000)
})

onBeforeUnmount(() => {
  clearTimeout(timeout.value)
})
</script>

<style scoped>
.notification-toast {
  width: 250px;
  letter-spacing: normal;
  z-index: 99999 !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
